<!-- 登录页面模版 -->
<template>
  <div class="login-frame">
    <div class="left">
      <div class="in">
        <div class="title">后台登录</div>
        <div class="sub">欢迎使用成旅聘通人才库</div>
      </div>
      <ul class="circles">
        <li v-for="item in 10" :key="item"></li>
      </ul>
    </div>
    <div class="right">
      <img src="@/assets/full_logo.png" alt="成旅聘通人才库" class="logo" />
      <div class="card">
        <div class="title">欢迎回来</div>
        <div class="tip">请输入您的账号密码</div>
        <el-form
          :model="loginForm"
          :rules="loginRules"
          ref="loginForm"
          hide-required-asterisk
          class="form"
        >
          <el-form-item prop="userName">
            <div class="box">
              <input
                type="text"
                v-model="loginForm.userName"
                @keyup.enter="submitForm('loginForm')"
                required
              />
              <label class="label">用户名</label>
            </div>
          </el-form-item>
          <el-form-item prop="password">
            <div class="box">
              <input
                type="password"
                v-model="loginForm.password"
                autocomplete="false"
                required
                @keyup.enter="submitForm('loginForm')"
              />
              <label class="label">密码</label>
            </div>
          </el-form-item>
          <el-form-item prop="code">
            <div class="verify">
              <div class="box">
                <input
                  v-model="loginForm.code"
                  autocomplete="false"
                  required
                  @keyup.enter="submitForm('loginForm')"
                />
                <label class="label">验证码</label>
              </div>
              <canvas
                id="code"
                width="100"
                height="40"
                @click="drawCode"
              ></canvas>
            </div>
          </el-form-item>
          <el-button
            type="primary"
            size=""
            class="login-btn"
            :disabled="loginForm.userName == '' || loginForm.password == ''"
            :loading="loading"
            round
            @click="submitForm('loginForm')"
            >登录</el-button
          >
        </el-form>
      </div>
      <div class="white"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const codeValid = (r, v, cb) => {
      if (this.code != v) {
        cb("请输入正确的验证码");
        return;
      }
      cb();
    };
    return {
      loading: false, //登录按钮
      code: "",
      loginForm: {
        userName: "",
        password: "",
        code: "",
      },
      loginRules: {
        userName: { required: true, message: "请输入账号", trigger: "blur" },
        password: { required: true, message: "请输入密码", trigger: "blur" },
        code: { validator: codeValid, trigger: "blur" },
      },
    };
  },
  mounted() {
    setTimeout(() => {
      this.drawCode();
    }, 100);
  },
  methods: {
    // 创建验证码数据
    createData() {
      const characters = "0123456789";
      let code = "";
      for (let i = 0; i < 4; i++) {
        let index = Math.floor(Math.random() * characters.length);
        code += characters.charAt(index);
      }
      return code;
    },
    // 绘制验证码
    drawCode() {
      const captchaCanvas = document.getElementById("code");
      const context = captchaCanvas.getContext("2d");
      this.code = this.createData();
      context.clearRect(0, 0, captchaCanvas.width, captchaCanvas.height);
      // 画布
      context.fillStyle = "#e2f4f4"; // 白色
      context.fillRect(0, 0, captchaCanvas.width, captchaCanvas.height);
      // 字体
      context.fillStyle = "#1b7d84";
      context.font = "24px Arial";
      context.fillText(this.code, 20, 30);

      // 绘制干扰线
      for (let i = 0; i < 4; i++) {
        context.beginPath();
        context.moveTo(
          Math.random() * captchaCanvas.width,
          Math.random() * captchaCanvas.height
        );
        context.lineTo(
          Math.random() * captchaCanvas.width,
          Math.random() * captchaCanvas.height
        );
        context.strokeStyle = this.getRandomColor();
        context.stroke();
      }
    },
    // 绘制时的随机颜色
    getRandomColor() {
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    // 登录验证
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          this.loginFunc();
        } else {
          this.drawCode();
        }
      });
    },
    // 登录
    loginFunc() {
      this.loading = true;
      this.$api
        .login(this.loginForm)
        .then((res) => {
          if (res.code != 0) {
            this.drawCode();
            return;
          }
          this.$notify({
            title: "登录成功!",
            type: "success",
          });
          localStorage.setItem("ch_token", res.data.token);
          localStorage.setItem("loginUser", JSON.stringify(res.data));
          this.$router.replace("/");
        })
        .catch(() => {
          this.$notify.error({
            title: "出现未知错误！请核查",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang='scss' scoped>
@keyframes animate {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
    border-radius: 0;
  }

  100% {
    transform: translateY(-1000px) rotate(720deg);
    opacity: 0;
    border-radius: 50%;
  }
}
.login-frame {
  width: 100vw;
  height: 100vh;
  display: flex;

  .left {
    flex-grow: 1;
    background-image: url("../../assets/img.jpeg");
    background-size: cover;
    background-position-x: center;
    position: relative;

    .in {
      color: #fff;
      position: absolute;
      left: 50%;
      top: 50%;
      z-index: 10;
      transform: translate(-50%, -50%);

      .title {
        font-size: 48px;
        font-weight: 700;
        margin-bottom: 20px;
      }
    }
    .circles {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;

      li {
        position: absolute;
        bottom: -150px;
        z-index: 10;
        display: block;
        list-style: none;
        width: 20px;
        height: 20px;
        background: rgba(255, 255, 255, 0.2);
        animation: animate 25s linear infinite;

        &:nth-child(1) {
          left: 25%;
          width: 80px;
          height: 80px;
          animation-delay: 0s;
        }
        &:nth-child(2) {
          left: 10%;
          width: 20px;
          height: 20px;
          animation-delay: 2s;
          animation-duration: 12s;
        }
        &:nth-child(3) {
          left: 70%;
          width: 20px;
          height: 20px;
          animation-delay: 4s;
        }
        &:nth-child(4) {
          left: 40%;
          width: 60px;
          height: 60px;
          animation-delay: 0s;
          animation-duration: 18s;
        }
        &:nth-child(5) {
          left: 65%;
          width: 20px;
          height: 20px;
          animation-delay: 0s;
        }
        &:nth-child(6) {
          left: 75%;
          width: 110px;
          height: 110px;
          animation-delay: 3s;
        }
        &:nth-child(7) {
          left: 35%;
          width: 150px;
          height: 150px;
          animation-delay: 7s;
        }
        &:nth-child(8) {
          left: 50%;
          width: 25px;
          height: 25px;
          animation-delay: 15s;
          animation-duration: 45s;
        }
        &:nth-child(9) {
          left: 20%;
          width: 15px;
          height: 15px;
          animation-delay: 2s;
          animation-duration: 35s;
        }
        &:nth-child(10) {
          left: 85%;
          width: 150px;
          height: 150px;
          animation-delay: 0s;
          animation-duration: 11s;
        }
      }
    }
  }
  .right {
    width: 40%;
    background-color: #fff;
    padding: 50px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    .logo {
      // max-width: 40%;
      max-height: 20%;
    }

    .card {
      width: 70%;
      margin: 0 auto;
      position: relative;

      .title {
        font-weight: 700;
        color: #333;
        font-size: 30px;
        text-align: center;
      }
      .tip {
        width: fit-content;
        margin: 0 auto;
        font-size: 14px;
        color: #d1d5db;
        margin-top: 30px;
        position: relative;

        &::before,
        &::after {
          content: "";
          display: block;
          width: 64px;
          height: 1px;
          background-color: #d1d5db;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
        &::before {
          left: -75px;
        }
        &::after {
          right: -75px;
        }
      }
      .form {
        margin-top: 30px;
      }
    }
    .white {
      height: 25%;
    }
  }
}
.box {
  margin-top: 10px;
  position: relative;
}
.box input {
  width: 100%;
  padding: 8px 16px;
  box-sizing: border-box;
  font-size: 16px;
  letter-spacing: 1px;
  border: none;
  border-radius: 20px;
  border-bottom: 1px solid #000;
  outline: none;
  background: transparent;
}
.verify .box input {
  border-bottom-right-radius: 0;
}
.box label {
  color: #999;
  position: absolute;
  bottom: 0;
  left: 16px;
  letter-spacing: 1px;
  font-size: 16px;
  pointer-events: none;
  transition: 0.5s;
}
.box input:focus + label,
.box input:valid + label {
  bottom: 20px;
  left: 0;
  color: #03a9f4;
  font-size: 12px;
}
.verify {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .box {
    flex-grow: 1;
  }
}
#code {
  cursor: pointer;
}
.login-btn {
  width: 100%;
  margin-top: 10px;
}

@media (max-width: 1000px) {
  .login-frame {
    .right {
      width: 50%;
    }
  }
}
@media (max-width: 750px) {
  .login-frame {
    .left {
      display: none;
    }
    .right {
      width: 100%;
    }
  }
}
</style>